import React from 'react';
import { withTranslation } from 'react-i18next';

// styles
import './ycStudio.scss';

import imgLY from '../../assets/images/c-team/lucas.png';
import imgJCY from '../../assets/images/c-team/jeanclaude.png';

import { YcAvatar } from '../YcAvatar';

export const YcStudio = withTranslation(['about-us'])(
  class YcStudioClass extends React.PureComponent {
    teamOwner = [
      { img: imgLY, name: 'Lucas Yalap', job: 'CEO & CTO', desc: 'about-us.founder.lucas' },
      {
        img: imgJCY,
        name: 'Jean-Claude Yalap',
        job: 'Founder & Lead Developer',
        desc: 'about-us.founder.jc',
      },
    ];

    renderEmploy(employ, active = false) {
      const { t } = this.props;
      return (
        <div key={employ.name} className="col-md-6 col-lg-4  block">
          <div className="img-block">
            <YcAvatar title={employ.name} img={employ.img} active={active} />
          </div>
          <div className="name">{employ.name}</div>
          {!!employ.job && <div className="job">{employ.job}</div>}
          <div className="desc">{t(employ.desc)}</div>
        </div>
      );
    }

    render() {
      const { t } = this.props;

      return (
        <div className="studio-content">
          <div className="page-projects__block page-projects__block-web">
            <div className="page-projects__block__text" style={{ background: 'white' }}>
              <div>
                <h2 dangerouslySetInnerHTML={{ __html: t('about-us.studio.title') }} />
                <h3 dangerouslySetInnerHTML={{ __html: t('about-us.studio.subtitle') }} />
                <p className="desc" dangerouslySetInnerHTML={{ __html: t('about-us.studio.desc') }} />
                <p className="page-projects__block-web__action">
                  <a href="#contact-us" onClick={event => this.clickLink('#contact-us', event)} className="action">
                    {t('projects.call-to-action')}
                  </a>
                </p>
              </div>
            </div>
            <div className="page-projects__block__image" />
          </div>
        </div>
      );
    }
  },
);
